/* eslint-disable no-console */
'use strict'

const state = {
  notification: {
    message: null,
    color: '#4CAF50',
    timeout: 6000,
    state: false,
    bottom: true,
    top: false,
    left: false,
    right: true
  }
}

const getters = {
  notification: state => state.notification
}
const mutations = {
  UPDATE_NOTIFICATION: (state, n) => {
    state.notification.message = n.message || state.notification.message || 'No message'
    state.notification.color = n.color || state.notification.color
    state.notification.timeout = n.timeout || state.notification.timeout
    state.notification.bottom = n.bottom || state.notification.bottom
    state.notification.top = n.top || state.notification.top
    state.notification.left = n.left || state.notification.left
    state.notification.right = n.right || state.notification.right
  },
  LAUNCH_NOTIFICATION: (state) => {
    state.notification.state = true
  },
  CLOSE_NOTIFICATION: (state) => {
    state.notification.color = '#4CAF50'
    state.notification.state = false
  }
}

const actions = {
  notify: (store, notification) => {
    store.commit('CLOSE_NOTIFICATION')
    store.commit('UPDATE_NOTIFICATION', notification)
    store.commit('LAUNCH_NOTIFICATION')
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
